import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getHourSlots, nameMaxLength } from '../../Constant.js'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import axios from 'axios'
import Toggle from 'react-toggle'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
class CompanyEventAddSub extends React.Component {
  state = {
    is_active: 'true',
    event_image: '',
    event_image_ar: '',
    isSaving: false,
    event_desc_ar: '',
    event_type: 'EVENT',
    event_desc_en: '',

    amount: '',
    monday_price: '',
    tuesday_price: '',
    wednesday_price: '',
    thursday_price: '',
    friday_price: '',
    saturday_price: '',
    same_price: false,

    child_amount: '',
    child_monday_price: '',
    child_tuesday_price: '',
    child_wednesday_price: '',
    child_thursday_price: '',
    child_friday_price: '',
    child_saturday_price: '',

    event_name_ar: '',
    pickup_id: '',
    event_name_en: '',
    restaurant_board_list_en: '',
    restaurant_board_list_ar: '',
    category_id: '',
    Category_data: [],
    categoryValueChange: [],
    isData: false,
    Edit: false,
    EditAr: false,
    minimum_booking_time: '',
    enable_b2b_prices: false,
    is_kashta: false,
    b2b_adult_price: null,
    b2b_child_price: null,

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',
    is_catering_available: false,
    requires_adult_ticket: true,
    location_name_en: '',
    location_name_ar: '',
    lat: '',
    long: ''
  }

  componentDidMount() {
    this.CategoryList()
    this.PickupList()

    if (this.props.id) {
      this.EventLists()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language_id !== this.props.language_id) {
      this.EventLists()
    }
  }

  PickupList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Products_data: res?.data?.data,
          })
        }
      })
      .catch((err) => {
        that.setState({ isData: false })

        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  EventLists = async () => {
    await axios
      .get(Constant.getAPI() + `/event/list-events`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          const matchItem = res.data?.data?.filter((itm) => itm.id === this.props.id)
          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState(
              {
                ...itm,
                Edit: true,
                EditAr: true,
              },
              () => {
                let temp = this.state.Category_data?.filter((itm) => itm?.category_type === this.state.event_type)
                this.setState({
                  categoryValueChange: temp,
                })
              }
            )
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChangeRestaurant_en = (event) => {
    this.setState({ restaurant_board_list_en: event })
  }

  handleChangeRestaurant_ar = (event) => {
    this.setState({ restaurant_board_list_ar: event })
  }

  handleChange = (event) => {
    if (event.target.name === 'event_type') {
      this.setState({
        event_type: event.target.value,
        categoryValueChange: this.state.Category_data?.filter((itm) => itm?.category_type === event.target.value),
      })
    } else if (event.target.name == 'enable_b2b_prices') {
      this.setState({ enable_b2b_prices: event.target.checked })
    } else if (event.target.name == 'is_kashta') {
      this.setState({ is_kashta: event.target.checked })
    } else if (event.target.name == 'is_active') {
      this.setState({ is_active: event.target.checked })
    } else if (event.target.name == 'same_price') {
      this.setState({ same_price: event.target.checked }, () => {
        if (this.state.same_price) {
          this.setState({
            monday_price: this.state.amount,
            tuesday_price: this.state.amount,
            wednesday_price: this.state.amount,
            thursday_price: this.state.amount,
            friday_price: this.state.amount,
            saturday_price: this.state.amount,

            child_monday_price: this.state.child_amount,
            child_tuesday_price: this.state.child_amount,
            child_wednesday_price: this.state.child_amount,
            child_thursday_price: this.state.child_amount,
            child_friday_price: this.state.child_amount,
            child_saturday_price: this.state.child_amount,
          })
        }
      })
    } else if (event.target.name == 'is_catering_available') {
      this.setState({ is_catering_available: event.target.checked })
    } else if (event.target.name == 'requires_adult_ticket') {
      this.setState({ requires_adult_ticket: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    if (e.target.name == 'event_image') {
      this.setState({ Edit: false })
      this.setState({ img: URL.createObjectURL(e.target.files[0]) })
    } else if (e.target.name == 'event_image_ar') {
      this.setState({ EditAr: false })
      this.setState({ img_ar: URL.createObjectURL(e.target.files[0]) })
    }
  }

  CategoryList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/event-categories/list-event-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Category_data: res.data?.data,
          })
          let temp
          if (res.data?.data) {
            temp = res.data?.data?.filter((itm) => itm?.category_type === 'EVENT')

            that.setState({
              categoryValueChange: temp,
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  dashbord = async () => {
    if (this.state.enable_b2b_prices && (!this.state.b2b_adult_price || !this.state.b2b_child_price)) {
      Swal.fire('Required !', 'B2b Adult & child price', 'error')
      return
    }
    var that = this
    const formData = new FormData()
    formData.append('is_active', that.state.is_active)
    formData.append('company_id', that.props.company_id)
    formData.append('event_desc_ar', that.state.event_desc_ar)
    formData.append('event_desc_en', that.state.event_desc_en)

    formData.append('amount', that.state.amount)
    formData.append('monday_price', that.state.monday_price)
    formData.append('tuesday_price', that.state.tuesday_price)
    formData.append('wednesday_price', that.state.wednesday_price)
    formData.append('thursday_price', that.state.thursday_price)
    formData.append('friday_price', that.state.friday_price)
    formData.append('saturday_price', that.state.saturday_price)

    formData.append('pickup_id', that.state.pickup_id)
    formData.append('event_name_ar', that.state.event_name_ar)
    formData.append('event_name_en', that.state.event_name_en)
    formData.append('restaurant_board_list_en', this.state.restaurant_board_list_en)
    formData.append('restaurant_board_list_ar', this.state.restaurant_board_list_ar)
    formData.append('event_type', that.state.event_type)
    formData.append('category_id', this.state.category_id === 'select_category' ? '' : this.state.category_id)

    formData.append('child_amount', this.state.child_amount)
    formData.append('child_monday_price', that.state.child_monday_price)
    formData.append('child_tuesday_price', that.state.child_tuesday_price)
    formData.append('child_wednesday_price', that.state.child_wednesday_price)
    formData.append('child_thursday_price', that.state.child_thursday_price)
    formData.append('child_friday_price', that.state.child_friday_price)
    formData.append('child_saturday_price', that.state.child_saturday_price)

    formData.append('max_tickets', this.state.max_tickets)
    formData.append('min_tickets', this.state.min_tickets)
    formData.append('enable_b2b_prices', this.state.enable_b2b_prices)

    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)
    formData.append('h1_ar', this.state.h1_ar)
    formData.append('h1_en', this.state.h1_en)
    formData.append('h2_ar', this.state.h2_ar)
    formData.append('h2_en', this.state.h2_en)
    formData.append('is_catering_available', this.state.is_catering_available)

    formData.append('is_kashta', this.state.is_kashta)
    formData.append('requires_adult_ticket', this.state.requires_adult_ticket)
    if (this.state.location_name_en) formData.append('location_name_en', this.state.location_name_en)
    if (this.state.location_name_ar) formData.append('location_name_ar', this.state.location_name_ar)
    if (this.state.lat) formData.append('lat', this.state.lat)
    if (this.state.long) formData.append('long', this.state.long)
    if (this.state.minimum_booking_time) {
      formData.append('minimum_booking_time', this.state.minimum_booking_time)
    } else {
      formData.append('minimum_booking_time', '')
    }

    if (this.state.enable_b2b_prices) {
      formData.append('b2b_adult_price', this.state.b2b_adult_price)
      formData.append('b2b_child_price', this.state.b2b_child_price)
    }

    if (that.props.id) {
      formData.append('id', that.props.id)
      if (that.state.event_image?.name) {
        formData.append('event_image', that.state.event_image)
      }
      if (that.state.event_image_ar?.name) {
        formData.append('event_image_ar', that.state.event_image_ar)
      }
      that.setState({ isData: true })

      await axios
        .put(Constant.getAPI() + '/event/edit-new-event', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          that.setState({ isData: false })
          Swal.fire({
            title: 'Event updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = `#/view-event-company/${this.props.company_id}`
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      if (that.state.event_image?.name) {
        formData.append('event_image', that.state.event_image)
      }
      if (that.state.event_image_ar?.name) {
        formData.append('event_image_ar', that.state.event_image_ar)
      }
      that.setState({ isData: true })

      await axios
        .post(Constant.getAPI() + '/event/add-new-event', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          that.setState({ isData: false })
          Swal.fire({
            title: 'Event added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = `#/view-event-company/${this.props.company_id}`
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Name : English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_name_en"
                    id="event_name_en"
                    placeholder="Event Name: English"
                    onChange={this.handleChange}
                    maxLength={nameMaxLength}
                    value={this.state.event_name_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.event_name_en
                    ? this.state.event_name_en.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Name : Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_name_ar"
                    id="event_name_ar"
                    placeholder="Event Name: Arabic"
                    maxLength={nameMaxLength}
                    onChange={this.handleChange}
                    value={this.state.event_name_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.event_name_ar
                    ? this.state.event_name_ar.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_desc_en"
                    id="event_desc_en"
                    placeholder="Event Description: English"
                    onChange={this.handleChange}
                    value={this.state.event_desc_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_desc_ar"
                    id="event_desc_ar"
                    placeholder="Event Description: Arabic"
                    onChange={this.handleChange}
                    value={this.state.event_desc_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Same Price for all days</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="same_price"
                    id="same_price"
                    onChange={this.handleChange}
                    checked={this.state.same_price}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Enable Catering</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="is_catering_available"
                    id="is_catering_available"
                    onChange={this.handleChange}
                    checked={this.state.is_catering_available}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Requires Adult Ticket</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="requires_adult_ticket"
                    id="requires_adult_ticket"
                    onChange={this.handleChange}
                    checked={this.state.requires_adult_ticket}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Adult Ticket Price</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">{this.state.same_price ? 'Price' : 'Sunday Price'}</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    id="amount"
                    placeholder="Price"
                    onChange={this.handleChange}
                    value={this.state.amount}
                  />
                </div>
              </div>
            </div>
            {!this.state.same_price && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Monday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="monday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.monday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Tuesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="tuesday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.tuesday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Wednesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="wednesday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.wednesday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Thursday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="thursday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.thursday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Friday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="friday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.friday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Saturday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="saturday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.saturday_price}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Child Ticket Price</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">{this.state.same_price ? 'Price' : 'Sunday Price'}</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="child_amount"
                    id="child_amount"
                    placeholder="Price"
                    onChange={this.handleChange}
                    value={this.state.child_amount}
                  />
                </div>
              </div>
            </div>
            {!this.state.same_price && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Monday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="child_monday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.child_monday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Tuesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="child_tuesday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.child_tuesday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Wednesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="child_wednesday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.child_wednesday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Thursday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="child_thursday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.child_thursday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Friday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="child_friday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.child_friday_price}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Saturday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="child_saturday_price"
                        placeholder="Price"
                        onChange={this.handleChange}
                        value={this.state.child_saturday_price}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>B2B Price</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Enable B2B Price</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="enable_b2b_prices"
                    id="enable_b2b_prices"
                    onChange={this.handleChange}
                    checked={this.state.enable_b2b_prices}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6"></div>
            {this.state.enable_b2b_prices && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Adult B2B Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="b2b_adult_price"
                        id="b2b_adult_price"
                        placeholder="Adult B2B Price"
                        onChange={this.handleChange}
                        value={this.state.b2b_adult_price}
                        min={0}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Child B2B Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="b2b_child_price"
                        id="b2b_child_price"
                        placeholder="Child B2B Price"
                        onChange={this.handleChange}
                        value={this.state.b2b_child_price}
                        min={0}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Min Tickets</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="min_tickets"
                    id="min_tickets"
                    placeholder="Min ticket"
                    onChange={this.handleChange}
                    value={this.state.min_tickets}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Max Tickets</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="max_tickets"
                    id="max_tickets"
                    placeholder="Max tickets"
                    onChange={this.handleChange}
                    value={this.state.max_tickets}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Minimum Booking Time</label>
                <div className="col-sm-9">
                  <select
                    name="minimum_booking_time"
                    className="form-control"
                    value={this.state.minimum_booking_time}
                    onChange={this.handleChange}
                  >
                    <option value={''}>Select time(HH:MM)</option>
                    {getHourSlots().map(
                      (item) =>
                        item.value != '00:00:00' && (
                          <option
                            value={item.value}
                            key={item.value}
                          >
                            {item.label}
                          </option>
                        )
                    )}
                    <option value={'48:00:00'}>48:00</option>
                    <option value={'72:00:00'}>72:00</option>
                    <option value={'96:00:00'}>96:00</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Pickup list</label>
                <div className="col-sm-9">
                  <select
                    name="pickup_id"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.pickup_id}
                  >
                    <option>Select pickup</option>
                    {this.state?.Products_data?.length > 0
                      ? this.state.Products_data?.filter((itm) => itm.is_active)?.map((itm) => (
                        <option
                          value={itm?.id}
                          key={itm?.id}
                        >
                          {itm?.pickup_address_en}
                          {' / '}
                          {itm?.pickup_address_ar}
                        </option>
                      ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            {this.state.is_kashta && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">
                      Location Name: English
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="location_name_en"
                        id="location_name_en"
                        placeholder="Location Name: English"
                        onChange={this.handleChange}
                        value={this.state.location_name_en}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">
                      Location Name: Arabic
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="location_name_ar"
                        id="location_name_ar"
                        placeholder="Location Name: Arabic"
                        onChange={this.handleChange}
                        value={this.state.location_name_ar}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Latitude</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        step="0.00000001"
                        className="form-control"
                        name="lat"
                        id="lat"
                        placeholder="Latitude"
                        onChange={this.handleChange}
                        value={this.state.lat}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Longitude</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        step="0.00000001"
                        className="form-control"
                        name="long"
                        id="long"
                        placeholder="Longitude"
                        onChange={this.handleChange}
                        value={this.state.long}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Type</label>
                <div className="col-sm-9">
                  <select
                    name="event_type"
                    className="form-control"
                    value={this.state.event_type}
                    onChange={this.handleChange}
                  >
                    <option
                      value="EVENT"
                      name="EVENT"
                    >
                      EVENT
                    </option>
                    <option
                      value="ACTIVITY"
                      name="ACTIVITY"
                    >
                      ACTIVITY
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Category</label>
                <div className="col-sm-9">
                  <select
                    name="category_id"
                    className="form-control"
                    value={this.state.category_id}
                    onChange={this.handleChange}
                  >
                    <option value="select_category">Select category</option>
                    {this.state.categoryValueChange?.length > 0
                      ? this.state.categoryValueChange
                        ?.filter((itm) => itm.is_active)
                        ?.map((categoryValueChange) => (
                          <option
                            value={categoryValueChange?.id}
                            key={categoryValueChange?.id}
                          >
                            {categoryValueChange?.category_name_en || '--'}
                            {' / '}
                            {categoryValueChange?.category_name_ar || '--'}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="is_active"
                    id="is_active"
                    onChange={this.handleChange}
                    checked={this.state.is_active}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Is Kashta Event</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="is_kashta"
                    id="is_kashta"
                    onChange={this.handleChange}
                    checked={this.state.is_kashta}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="event_image"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 1:1 Ratio or 900 x 900</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.Edit ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.event_image}
                      alt="img"
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.img}
                      alt="img"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3"> Image: Arabic</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="event_image_ar"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 1:1 Ratio or 900 x 900</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.EditAr ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.event_image_ar}
                      alt="img"
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.img_ar}
                      alt="img"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Details/تفاصيل</label>
                <div className="col-sm-12">
                  {this.props.language_id === 'en' ? (
                    <ReactQuill
                      className="form-control"
                      name="restaurant_board_list_en"
                      id="restaurant_board_list_en"
                      value={this.state.restaurant_board_list_en}
                      onChange={this.handleChangeRestaurant_en}
                    />
                  ) : (
                    <ReactQuill
                      className="form-control"
                      name="restaurant_board_list_ar"
                      id="restaurant_board_list_ar"
                      value={this.state.restaurant_board_list_ar}
                      onChange={this.handleChangeRestaurant_ar}
                    />
                  )}
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
              <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</h5>
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_en"
                      id="meta_title_en"
                      placeholder="Meta Title: English"
                      onChange={this.handleChange}
                      value={this.state.meta_title_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_ar"
                      id="meta_title_ar"
                      placeholder="Meta Title: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_title_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_en"
                      id="meta_keywords_en"
                      placeholder="Meta keywords: English"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_ar"
                      id="meta_keywords_ar"
                      placeholder="Meta keywords: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_en"
                      id="meta_desc_en"
                      placeholder="Meta Description: English"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_ar"
                      id="meta_desc_ar"
                      placeholder="Meta Description: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_en"
                      id="h1_en"
                      placeholder="H1: English"
                      onChange={this.handleChange}
                      value={this.state.h1_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_ar"
                      id="h1_ar"
                      placeholder="H1: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h1_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_en"
                      id="h2_en"
                      placeholder="H2: English"
                      onChange={this.handleChange}
                      value={this.state.h2_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_ar"
                      id="h2_ar"
                      placeholder="H2: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h2_ar}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>
          </div>

          <div className="row float-right p-3">
            <button
              onClick={this.dashbord}
              className="btn btn-grd-disabled mr-2"
            >
              <i className="icofont icofont-save"></i> Save
            </button>

            <Link
              to={'/view-event-company'}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default CompanyEventAddSub
